<template>
  <BasicGridTable :disabled="disabled" grid-name="service-library" header-class="d-none d-md-grid">
    <BasicGridTableHeader v-for="f of fields"
                          slot="header"
                          :key="'item__' + f.key"
                          :sortable="f.sortable"
                          :sorting-active="sortingKey === f.key"
                          :sorting-dir="sortingDir"
                          :name="f.key"
                          @click.native="f.sortable ? $emit('sorting', f.key, sortingKey === f.key && sortingDir === '-' ? '+' : '-') : null"
    >
      {{ f.label }}
    </BasicGridTableHeader>

    <div slot="rows" class="px-3 px-sm-0">
      <ServiceLibraryItem v-for="(item,i) of items" :key="'item' + i" :item="item" v-on="$listeners" />

      <div v-if="!items.length">
        <div class="box" data-test-id="no-results-message">
          {{ 'noResults' | translate(labels, 'servicelibrary_ServiceLibraryComponent') }}
        </div>
      </div>
    </div>
  </BasicGridTable>
</template>

<script>
import BasicGridTable from '@/components/ui/BasicGridTable'
import ServiceLibraryItem from '@/components/ServiceLibrary/ServiceLibraryItem'
import BasicGridTableHeader from '@/components/ui/BasicGridTableHeader'

export default {
  conceptName: ['servicelibrary_ServiceLibraryComponent', 'shared_CommonFunctional'],
  components: {
    BasicGridTable,
    BasicGridTableHeader,
    ServiceLibraryItem
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: true
    },
    items: {
      required: true
    },
    sortingDir: {
      type: String,
      default: null,
      required: false
    },
    sortingKey: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    fields() {
      return [
        {key: 'title', label: this.$options.filters.translate('refNoHeader', this.labels, 'shared_CommonFunctional'), sortable: true},
        {key: 'description', label: this.$options.filters.translate('descriptionHeader', this.labels, 'shared_CommonFunctional'), sortable: true},
        {key: 'category', label: this.$options.filters.translate('categoryHeader', this.labels, 'shared_CommonFunctional'), sortable: true},
        {key: 'language_code', label: this.$options.filters.translate('languageHeader', this.labels, 'shared_CommonFunctional')}
      ]
    }
  }
}
</script>
